var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('report-template-form',{staticClass:"pa-4",on:{"save":_vm.save},model:{value:(_vm.payload),callback:function ($$v) {_vm.payload=$$v},expression:"payload"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }